import { useState } from "react";

const useTwoFACode = (length = 6) => {
  const [code, setCode] = useState(Array(length).fill(""));

  const updateCode = (index, value) => {
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
  };

  const resetCode = () => setCode(Array(length).fill(""));

  const getCodeString = () => code.join("");

  return {
    code,
    updateCode,
    resetCode,
    getCodeString
  };
};

export default useTwoFACode;
